import {useEffect} from 'react'
import {useRouter} from 'next/router'

import {Datalayer} from '@miro-site/analytics'

import getAnalytics from '../analytics'
import checkUserInfo from '../utils/checkUserInfo'

const useAnalytics = (): void => {
  const router = useRouter()

  useEffect(() => {
    const trackPageView = (url: string) => {
      setTimeout(async () => {
        const analytics = await getAnalytics()
        const {id: userId} = checkUserInfo() || {}

        analytics.sendEvent(
          new Datalayer('pageview', {
            pagePath: url,
            pageTitle: document.title,
            userId,
          }),
        )
      }, 1500)
    }

    trackPageView(router.basePath + router.asPath)
    router.events.on('routeChangeComplete', trackPageView)

    return () => {
      router.events.off('routeChangeComplete', trackPageView)
    }
  }, [])
}

export default useAnalytics
